module.exports = __webpack_public_path__ + "static/img/wireless-img-right.84eca237.png";